import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { APIErrorResponse } from '@/types'
import { getUseInternalHoursLogsKey } from './useInternalHoursLogs'
import { getUseInternalHoursBalanceKey } from './useInternalHoursBalance'

export const useDeleteInternalHoursLog = (
  id: number
): UseMutationResult<unknown, APIErrorResponse, void> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const listKey = getUseInternalHoursLogsKey()
  const balanceKey = getUseInternalHoursBalanceKey()

  return useMutation(
    () =>
      client
        .delete(`/hours_reporting/internal-hours/${id}/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries(listKey),
          queryClient.invalidateQueries(balanceKey),
        ])
      },
    }
  )
}
